import $ from 'jquery';

import React from 'react';
import {createRoot} from 'react-dom/client';
import {configureStore} from '@reduxjs/toolkit';
import {Provider} from 'react-redux';

import {APIContext} from '../shared/api/api-context';
import {CometContext} from '../shared/api/comet/comet-context';

import Class from '../tabs/legacy/legacy-class';
import brand from '../shared/app/model/branding';

import Settings from '../tabs/legacy/settings';
import DeviceManager from '../device/device-manager';
import TempLimitsNotification from '../tabs/legacy/temp-limits-notification';
import {BrowserNotificationManager} from '../utils/browser-notifications';
import Event from '../tabs/legacy/event';
import OpenThermDialog from '../tabs/legacy/opentherm-dialog/opentherm-dialog';
import {installDateChecker} from '../redux/data-actions';
import {get_initial_ui_settings} from '../redux/settings-actions';
import UAParser from 'ua-parser-js';

import '../utils/pull-to-refresh';
import {elementIsInsideClassNames, initPullToRefresh} from '../utils/pull-to-refresh';
import {setPeriod} from '../period/actions';
import {isProduction, todayEndToUnix, todayStartToUnix} from '../../utils';
import {selectThemeType} from '../theme/selector';
import {createCometListeners} from '../shared/api/comet/comet-listeners';
import {forceUpdateState} from '../redux/devices/items/actions';
import {
    markAllEventsAsRead,
    openImportantEventsDialog,
    requestGetAllStates,
    showEventOnMap,
} from '../redux/main-actions';
import {reducers} from '../redux/app-reducer';
import {baseTheme} from '../theme/styles/base-theme';
import {selectSelectedDevice} from '../entities/device/lib';
import {idleDidLeave, markStale, markUpToDate} from '../idle/reducer';
import {listenerMiddleware} from '../idle/middleware';
import {reloadDevice} from '../device/reload-device';
import {listenerMiddlewareMapDashboard} from '../pages/dashboard.map/model/middleware';
import {
    listenerMiddlewareDeleteSelectedDevice,
    listenerMiddlewareSelectedDevice,
} from '../redux/devices/selected-id/middleware';
import {openSessionEndedDialog} from '../features/account.session-ended/model/reducer';
import {listenerMiddlewareUpdateZ3KConfigHistory} from '../device-settings/z3k/components/view-config/redux/middleware';

function _fix_iPad() {
    const parser = new UAParser().getResult();
    if (parser.device.type === 'iPad' && ~~parser.os.version.split('.')[0] === 7) {
        const fixDocSize = function () {
            if (window.innerHeight >= 672) {
                document.documentElement.style.height = window.innerHeight + 'px';

                if (document.body.scrollTop !== 0) window.scrollTo(0, 0);
            }
        };

        window.addEventListener('scroll', fixDocSize, false);
        window.addEventListener('orientationchange', fixDocSize, false);
        fixDocSize();

        document.body.style.webkitTransform = 'translate3d(0,0,0)';

        // $(document).on('touchstart', function (e) { e.preventDefault() })
    }
}

export const BaseUI = Class({
    init: function (account, api, comet, render_ui, perflog = () => {}) {
        perflog('base-ui 0');

        this.render_ui = render_ui;

        _fix_iPad();

        perflog('base-ui 1');

        this._server_preload_time = PRELOAD.server_time;
        this._local_preload_time = new Date().getTime() / 1e3;

        this.account = account;
        this.api = api;

        perflog('base-ui 2');

        // Check for invalid client's time
        if (
            Math.abs(parseInt(new Date().getTime() / 1000, 10) - PRELOAD.server_time) >
            10 * 60
        ) {
            console.error(
                'INVALID TIME',
                'client_tz',
                new Date().getTimezoneOffset() / -60,
                'client_local_time',
                new Date(),
                'preload_time',
                PRELOAD.server_time
            );
            $.mui.mui_dialog.errorbox({
                title: 'Неправильное время',
                message:
                    '<p>Похоже, что на вашем компьютере установлено неправильное время.</p>' +
                    '<p>Некоторые функции ' +
                    brand.name_html +
                    ' могут работать неправильно.</p>' +
                    '<p>&nbsp;</p>' +
                    '<p><a target="_blank" href="http://wiki.microline.ru/timezones-2014">Инструкция по настройке новых часовых поясов<br/>на компьютере и смартфоне</a></p>',
            });
        }

        perflog('base-ui 4');

        const initial_ui_settings = get_initial_ui_settings(PRELOAD);

        this.comet = comet;

        this.devices = new DeviceManager(
            this,
            PRELOAD.devices,
            initial_ui_settings.selected_device_id
        );
        this.devices.bind(
            'deviceEvent',
            function (device, eventname, eventargs) {
                if (eventname == 'access:weekschedule') {
                    this.store.dispatch(reloadDevice());
                }
            }.bind(this)
        );

        perflog('base-ui 9');

        comet.onConnected = () => this.store.dispatch(markUpToDate());
        comet.onConnectionLost = () => this.store.dispatch(markStale());
        comet.onReloadData = () => this.store.dispatch(reloadDevice());
        comet.onAuthError = () => this.store.dispatch(openSessionEndedDialog());

        perflog('base-ui 10');

        perflog('base-ui 11');

        var browser_notification_manager = null;
        if (BrowserNotificationManager.available())
            browser_notification_manager = new BrowserNotificationManager((event) =>
                this.show_event_on_map(new Event(event))
            );

        perflog('base-ui 12');
        this.store = configureStore({
            reducer: reducers(PRELOAD),
            middleware: (getDefaultMiddleware) =>
                getDefaultMiddleware({
                    immutableCheck: isProduction(),
                    serializableCheck: isProduction(),
                    thunk: {
                        extraArgument: {
                            api: this.api,
                            comet: this.comet,
                            device_manager: this.devices,
                            browser_notification_manager,
                            open_device_settings_dialog: () =>
                                this.open_device_settings_dialog(),
                            open_ot_diagnostics_dialog: (device_id) =>
                                OpenThermDialog.for_device(
                                    this,
                                    this.devices.device(device_id)
                                ).open(),
                            logout: this.notifier('logout'),
                        },
                    },
                }).prepend([
                    listenerMiddleware.middleware,
                    listenerMiddlewareMapDashboard.middleware,
                    listenerMiddlewareSelectedDevice.middleware,
                    listenerMiddlewareDeleteSelectedDevice.middleware,
                    listenerMiddlewareUpdateZ3KConfigHistory.middleware,
                ]),
            devTools: !isProduction(),
        });

        if (process.env.NODE_ENV !== 'production' && module.hot) {
            module.hot.accept('../redux/app-reducer', () =>
                this.store.replaceReducer(reducers(PRELOAD))
            );
        }

        perflog('base-ui 13');

        perflog('create comet listeners');

        createCometListeners(this.comet, this.store.dispatch);

        perflog('base-ui 13');

        this.settings = new Settings(
            this.store,
            this.account.is_guest() || this.account.is_demo()
        );

        perflog('base-ui 14');

        this.comet.setActive(true);

        perflog('base-ui 15');

        installDateChecker(this.store.dispatch, this.store.getState);

        perflog('base-ui 16');

        new TempLimitsNotification(this);

        perflog('base-ui 17');

        this._createUI(perflog);
        perflog('base-ui 18');
        this._raiseOnUICreated();
        perflog('base-ui 19');

        setInterval(() => this.force_update_store_every_minutes(), 6e4);

        initPullToRefresh({
            shouldActivateOnElement: (element) =>
                !elementIsInsideClassNames(element, [
                    'r-map-container',
                    'leaflet-container',
                    'ui-time-graph-plot',
                    'ui-splitter',
                    'mui_basedialog',
                    'mui_basedialog_dimmer',
                    'r-dialog-container',
                    'MuiDialog-container',
                    'fancy-temp-control',
                    'day-schedule-editor',
                    'swipable-overlay',
                    'swipable-modal',
                    'tree',
                    'swiper',
                    'swiper-container',
                    'sortable-fallback',
                    'dashboard-sorting-mode',
                    'drag-list-drag-active',
                    'react-joyride__overlay',
                    'MuiBackdrop-root',
                    'MobileLeftMenu',
                ]),
            onRefresh: async () => {
                try {
                    this.store.dispatch(idleDidLeave());
                    this.store.dispatch(requestGetAllStates());
                } catch (e) {
                    console.error(e);
                }
            },
        });
    },

    _createUI: function (perflog) {
        perflog('_createUI 0');

        var container = document.createElement('div');
        container.style.width = '100%';
        container.style.height = '100%';
        document.body.appendChild(container);
        const root = createRoot(container);

        perflog('_createUI 1');

        root.render(
            <CometContext.Provider value={this.comet}>
                <APIContext.Provider value={this.api}>
                    <Provider store={this.store}>{this.render_ui(this)}</Provider>
                </APIContext.Provider>
            </CometContext.Provider>
        );

        perflog('_createUI 2');
    },

    // reload_devices: async function () {
    //     this.store.dispatch(markStale());
    //
    //     let json;
    //     while (!this.store.getState().idle.idle) {
    //         try {
    //             json = await this.api.call_v2({
    //                 method: 'devices',
    //                 data: {load_io: true},
    //             });
    //             break;
    //         } catch (e) {
    //             const delay = 1e3;
    //             console.error(`Can't reload devices, waiting ${delay}ms and retrying`);
    //             // async version of sleep(delay)
    //             await new Promise((resolve) => setTimeout(resolve, delay));
    //         }
    //     }
    //
    //     try {
    //         this.devices.update_from_json(json.devices);
    //         this.store.dispatch(applyDevicesJson(json.devices));
    //     } finally {
    //         this.store.dispatch(markUpToDate());
    //     }
    // },

    onUICreated: function (handler) {
        if (this._uiCreated) handler.apply(this);
        else {
            if (this._uiCreatedHandlers) this._uiCreatedHandlers.push(handler);
            else this._uiCreatedHandlers = [handler];
        }
    },

    _raiseOnUICreated: function () {
        if (!this._uiCreated) {
            if (this._uiCreatedHandlers) {
                for (var i = 0; i < this._uiCreatedHandlers.length; i++)
                    this._uiCreatedHandlers[i].apply(this);

                delete this._uiCreatedHandlers;
            }

            this._uiCreated = true;
        }
    },

    current_server_time: function () {
        return (
            new Date().getTime() / 1e3 -
            this._local_preload_time +
            this._server_preload_time
        );
    },

    show_event_on_map: function (event) {
        if (event.loc()) this.store.dispatch(showEventOnMap(event));
    },
    get_period: function () {
        if (this.store != null) {
            const period = this.store.getState().period;
            //Если открылись впервые
            if (period.mintime == null || period.maxtime == null) {
                return {
                    mintime: todayStartToUnix(),
                    maxtime: todayEndToUnix(),
                };
            }
            return period;
        }
        return null;
    },
    set_period: function (mintime, maxtime) {
        this.store.dispatch(setPeriod(mintime, maxtime));
    },

    open_device_settings_dialog: async function (page_id) {
        try {
            const {get_settings_dialog_class} = await import(
                // webpackChunkName: 'device-settings'
                '../device-settings/dialog-class'
            );
            get_settings_dialog_class()
                .instance()
                .open(this, this.devices.selectedDevice(), {
                    initial_page_id: page_id,
                });
        } catch (error) {
            console.error(error);
            alert('Не удалось загрузить настройки, попробуйте перезагрузить страницу');
        }
    },

    open_important_events_dialog: function () {
        this.store.dispatch(openImportantEventsDialog());
    },

    mark_all_events_as_read: function () {
        this.store.dispatch(markAllEventsAsRead());
    },

    getUITheme: function () {
        return baseTheme(selectThemeType(this.store.getState()));
    },

    selectedDevice: function () {
        return selectSelectedDevice(this.store.getState());
    },

    // This function is needed to force the store to update the status of the devices once a minute
    force_update_store_every_minutes: function () {
        return this.store.dispatch(forceUpdateState());
    },
}).implement(Class.EventSource);
